<template>
<div class="chapter">
<div class="inner_page">
<p class="fm1"><span><i>From far, from eve and morning</i></span></p>
<p class="fm2"><span><i>And yon twelve-winded sky</i>,</span></p>
<p class="fm2"><span><i>The stuff of life to knit me</i></span></p>
<p class="fm2"><span><i>Blew hither: here am I</i>.</span></p>
<p class="fm3"><span><i>Now—for a breath I tarry</i></span></p>
<p class="fm2"><span><i>Nor yet disperse apart</i>—</span></p>
<p class="fm2"><span><i>Take my hand quick and tell me</i>,</span></p>
<p class="fm2"><span><i>What have you in your heart</i>.</span></p>
<p class="fm3"><span><i>Speak now, and I will answer;</i></span></p>
<p class="fm2"><span><i>How shall I help you, say;</i></span></p>
<p class="fm2"><span><i>Ere to the wind’s twelve quarters</i></span></p>
<p class="fm2"><span><i>I take my endless way</i>.</span></p>
<p class="center-1"><span>—<i>A. E. Housman</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?4e1df236